const accessControl = {
  pageTitle: 'पहुंच नियंत्रण',
  pageSubtitle: 'प्लेटफ़ॉर्म पर उपयोगकर्ता खातों, भूमिकाओं और पहुंच अनुमतियों का प्रबंधन करें',
  totalUsers: 'कुल उपयोगकर्ता',
  activeUsers: 'सक्रिय उपयोगकर्ता',
  pendingUsers: 'लंबित उपयोगकर्ता',
  inactiveUsers: 'निष्क्रिय उपयोगकर्ता',
  userName: 'उपयोगकर्ता नाम',
  email: 'ईमेल',
  phone: 'फ़ोन',
  role: 'भूमिका',
  lastLogin: 'अंतिम लॉगिन',
  created: 'बनाया गया',
  noUsersFound: 'आपकी खोज से मेल खाने वाला कोई उपयोगकर्ता नहीं मिला।',
  tryAdjustingFilters: 'अपनी खोज या फ़िल्टर समायोजित करने का प्रयास करें।',
  usersCount: '{{count}} उपयोगकर्ता',
  usersCountPlural: '{{count}} उपयोगकर्ता',
  createUser: 'उपयोगकर्ता बनाएं',
  editRole: 'भूमिका संपादित करें',
  resendDetails: 'विवरण पुनः भेजें',
  sendDetails: 'विवरण भेजें',
  changeRole: 'भूमिका बदलें',
  saveRole: 'भूमिका सहेजें',
  deactivateUser: 'उपयोगकर्ता निष्क्रिय करें',
  activateUser: 'उपयोगकर्ता सक्रिय करें',
  createUserTitle: 'नया उपयोगकर्ता बनाएं',
  createUserSubtitle: 'प्लेटफ़ॉर्म पर नया उपयोगकर्ता जोड़ने के लिए विवरण भरें',
  userNamePlaceholder: 'पूरा नाम दर्ज करें',
  emailPlaceholder: 'ईमेल पता दर्ज करें',
  phonePlaceholder: '+91 XXXXX XXXXX',
  selectRole: 'एक भूमिका चुनें',
  autoGeneratedPassword: 'स्वतः-निर्मित पासवर्ड',
  passwordNote: 'एक सुरक्षित पासवर्ड स्वतः उत्पन्न होगा। आप ईमेल के माध्यम से उपयोगकर्ता के साथ क्रेडेंशियल साझा कर सकते हैं।',
  createAndSend: 'बनाएं और विवरण भेजें',
  createOnly: 'उपयोगकर्ता बनाएं',
  userCreated: 'उपयोगकर्ता सफलतापूर्वक बनाया गया!',
  userCreatedAndSent: 'उपयोगकर्ता बनाया गया और क्रेडेंशियल ईमेल द्वारा भेजे गए।',
  roleUpdated: 'भूमिका सफलतापूर्वक अपडेट की गई।',
  detailsResent: '{{email}} पर क्रेडेंशियल पुनः भेजे गए।',
  detailsSent: '{{email}} पर क्रेडेंशियल भेजे गए।',
  userDeactivated: 'उपयोगकर्ता निष्क्रिय कर दिया गया है।',
  userActivated: 'उपयोगकर्ता सक्रिय कर दिया गया है।',
  confirmDeactivateTitle: 'उपयोगकर्ता निष्क्रिय करें?',
  confirmDeactivateMessage: 'यह उपयोगकर्ता प्लेटफ़ॉर्म तक पहुंच खो देगा। आप बाद में इसे पुनः सक्रिय कर सकते हैं।',
  confirmActivateTitle: 'उपयोगकर्ता सक्रिय करें?',
  confirmActivateMessage: 'यह इस उपयोगकर्ता के लिए प्लेटफ़ॉर्म पहुंच बहाल करेगा।',
  confirmResendTitle: 'क्रेडेंशियल पुनः भेजें?',
  confirmResendMessage: 'एक नया पासवर्ड उत्पन्न होगा और क्रेडेंशियल {{email}} पर ईमेल किए जाएंगे।',
  searchUsers: 'उपयोगकर्ता खोजें...',
  filterByRole: 'भूमिका के अनुसार फ़िल्टर',
  filterByStatus: 'स्थिति के अनुसार फ़िल्टर',
  allRoles: 'सभी भूमिकाएं',
  allStatuses: 'सभी स्थितियां',
  accessControlBreadcrumb: 'पहुंच नियंत्रण',
};

export default accessControl;